"use client"
import React from 'react'
import Navbar from '../../components/client/common/Navbar';
import MainExistApplications from '../../components/client/ExistApplication/MainExistApplication';

const ExistApplication = () => {

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="p-4 md:p-8">
       <MainExistApplications/>
      </main>
    </div>
  )
}

export default ExistApplication
